import { NavLink } from 'react-router-dom'
import Container from './menucontainer'
import DropdownContent from './dropdowncontent'
import { useState } from 'react'
import { translate, app } from '../app'
import { languages } from '../locale'
import { formatMenuTitle, menuContainsExternalLinks, isExternalLink } from '../helpers'
import { DownOutlined, UpOutlined } from './icons'

const MenuItem = ({ title, link, children, onToggle, active, setIsDrawerOpen, tabIndex = 0 }) => {

  const [visible, setVisible] = useState(false)
  const locale = languages[app.locale]?.zendesk as string ?? app.locale

  const handleMouseLeave = () => { setVisible(false) }
  const isRTL = languages[app.locale]?.rtl
  const uppercaseTitles =
    isExternalLink(link) || menuContainsExternalLinks(children)
  const displayTitle = formatMenuTitle(translate(title), uppercaseTitles)

  const handleNavLinkClick = (e) => {
    if (!children) {
      e.stopPropagation()
    } else if (onToggle) {
      onToggle()
    }
  }

  return <li onMouseLeave={() => setVisible(false)} className='max-w-screen'>
    <div className={`nav_item_content py-4 lg:py-[26px] ${isRTL ? 'pr-4' : 'pl-4'}`}>
      <NavLink to={`/${locale.toLowerCase()}/${link}`} className={({ isActive }) => (isActive ? 'truncate active no-underline !p-0' : 'no-underline !p-0')} onClick={handleNavLinkClick} onMouseEnter={() => setVisible(true)} onFocus={() => setVisible(true)} tabIndex={tabIndex}>
        {setIsDrawerOpen && <h2>{displayTitle}</h2>}{!setIsDrawerOpen && (<>{displayTitle}<DownOutlined aria-hidden="true" className={`${isRTL ? 'mr-2' : 'ml-2'} dropdown-icon ${visible ? 'open' : ''}`} /></>)}
      </NavLink>
      {children && (
        <button className={`${isRTL ? 'ml-1' : 'mr-1'} lg:hidden nav-button`} onClick={onToggle} aria-label="Toggle dropdown" aria-haspopup="menu" aria-expanded={active ? 'true' : 'false'} tabIndex={tabIndex}>
          {active ? <UpOutlined aria-hidden="true" /> : <DownOutlined aria-hidden="true" />}
        </button>
      )}
    </div>
    {children && (
      <div
        className={`dropdown border border-[#DDDDDD] border-solid border-t-0 lg:border-t border-r-0 border-l-0 !p-0 ${active ? 'h-auto' : 'h-0 overflow-hidden lg:h-auto'} ${visible ? 'visible' : 'lg:invisible'}`}
        onMouseLeave={handleMouseLeave}
      >
        <Container>
          <DropdownContent submenuscontent={children} setIsDrawerOpen={setIsDrawerOpen} handleClick={handleMouseLeave} uppercaseTitles={uppercaseTitles} />
        </Container>
      </div>
    )}
  </li>

}

export default MenuItem